module.exports = __webpack_public_path__ + "static/media/secure.93f0cbe3.svg";